/* eslint-disable import/no-anonymous-default-export */
export default {
  veterinarians: {
    list: [],
    loading: false,
    current: null,
    error: null,
    fetching: true,
  },
};
